import { render, staticRenderFns } from "./TrendLive.vue?vue&type=template&id=884a8bd2&scoped=true&"
import script from "./TrendLive.vue?vue&type=script&lang=js&"
export * from "./TrendLive.vue?vue&type=script&lang=js&"
import style0 from "./TrendLive.vue?vue&type=style&index=0&id=884a8bd2&scoped=true&lang=scss&"
import style1 from "./TrendLive.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884a8bd2",
  null
  
)

export default component.exports